module.exports = __webpack_public_path__ + "static/media/arch.6719434f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arch.jpg
// module id = 5795
// module chunks = 0